import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { pushOneEthnicGroup } from "../../../../middlewares/sysNavigation/SysNavigation";
import { useEthnicGroupContext } from "../../../../context/ethnicGroup/EthnicGroupContext";
import { Modal, Button, Search, Pagination } from "../../component/Component";
import { _PAGE_SIZE_ } from "../../../../middlewares/other/tools";

const addRoute = "/ethnic/group/add";
const editRoute = "/ethnic/group/edit";

const Overview = () => {
  let [ethnicGroupList, setEthnicGroupList] = useState([]);
  const { ethnicGroup, fetchEthnicGroups, count } = useEthnicGroupContext();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  useEffect(() => {
    if (!ethnicGroup) fetchEthnicGroups(page, pageSize);
    setEthnicGroupList(ethnicGroup);
  }, [ethnicGroup]); // eslint-disable-line

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    let searchArray = [];
    if (ethnicGroup !== null && ethnicGroup !== undefined)
      ethnicGroup.map((_ethnicGroup_) => {
        if (_ethnicGroup_.name.toString().toLowerCase().includes(key))
          return searchArray.push(_ethnicGroup_);
        return true;
      });

    setEthnicGroupList(searchArray);
    if (key === "") setEthnicGroupList(ethnicGroup);
  };

  return (
    <div className="p-3 lg:p-6 h-full overflow-y-auto bg-gray-50">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-sky-100 text-sky-600">
              {/* users icon */}
              <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor">
                <path d="M16 11a4 4 0 10-3.999-4.001A4 4 0 0016 11zM8 13a4 4 0 10-3.999-4.001A4 4 0 008 13zM16 13c-2.67 0-8 1.336-8 4v1a1 1 0 001 1h14a1 1 0 001-1v-1c0-2.664-5.33-4-8-4zM8 15c-2.4 0-7 1.202-7 3.6V20a1 1 0 001 1h8.05A5.8 5.8 0 018 19v-1c0-1.14.53-2.066 1.41-2.82C9.01 15.06 8.5 15 8 15z" />
              </svg>
            </span>
            <div>
              <h1 className="text-xl font-semibold leading-tight text-gray-900">
                Ethnic Groups
              </h1>
              <p className="text-sm text-gray-500">Browse, edit, and manage groups.</p>
            </div>
          </div>

          <span className="hidden sm:inline-flex rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700">
            Total: {count ?? 0}
          </span>
        </div>

        {/* Search + Add */}
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
          <div className="sm:col-span-2">
            <Search
              props={{
                title: "Ethnic Group",
                onChange: (e) => SearchList(e),
              }}
            />
          </div>
          <div className="w-full sm:justify-self-end">
            <Link to={addRoute}>
              <Button
                props={{
                  type: "button",
                  title: "Add Ethnic Group",
                  category: "default",
                  action: "add",
                  onClick: null,
                }}
              />
            </Link>
          </div>
        </div>

        {/* Table Card */}
        <div className="mt-5 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead className="sticky top-0 z-10 bg-gray-50/80 backdrop-blur">
                <tr className="text-gray-600">
                  <th className="w-2/3 px-4 py-3 border-b border-gray-200 font-semibold">
                    <div className="inline-flex items-center gap-2">
                      <svg className="h-4 w-4 text-gray-400" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 12a5 5 0 10-5-5 5 5 0 005 5zm-7 9a7 7 0 0114 0v1H5z" />
                      </svg>
                      <span>Name</span>
                    </div>
                  </th>
                  <th className="w-1/3 px-4 py-3 border-b border-gray-200 font-semibold text-right">
                    <div className="inline-flex items-center gap-2">
                      <svg className="h-4 w-4 text-gray-400" viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="5" cy="12" r="2" />
                        <circle cx="12" cy="12" r="2" />
                        <circle cx="19" cy="12" r="2" />
                      </svg>
                      <span>Actions</span>
                    </div>
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {ethnicGroup ? (
                  (() => {
                    if (!ethnicGroupList) ethnicGroupList = [...ethnicGroup];
                    return ethnicGroupList.map((_ethnicGroup_) => (
                      <tr
                        key={_ethnicGroup_.ethnic_group_id}
                        className="odd:bg-white even:bg-gray-50 hover:bg-sky-50/60 transition-colors"
                      >
                        <td className="px-4 py-3 align-middle">
                          <div className="flex items-center gap-3">
                            <span className="grid h-8 w-8 place-items-center rounded-lg bg-gray-900 text-white text-[11px] font-bold">
                              {(String(_ethnicGroup_.name).slice(0, 2) || "EG").toUpperCase()}
                            </span>
                            <span className="truncate font-medium text-gray-900">
                              {_ethnicGroup_.name}
                            </span>
                          </div>
                        </td>
                        <td className="px-4 py-3 align-middle">
                          <div className="flex justify-end">
                            <ActionButton props={_ethnicGroup_} />
                          </div>
                        </td>
                      </tr>
                    ));
                  })()
                ) : (
                  <tr className="odd:bg-white even:bg-gray-50">
                    <td className="px-4 py-6 text-gray-400">Loading...</td>
                    <td className="px-4 py-6 text-right text-gray-400">Loading...</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Pagination */}
        <div className="mt-4">
          <Pagination
            page={page}
            setPage={setPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total_items={count}
            callbackFunction={(_page_, _pageSize_) => {
              fetchEthnicGroups(_page_, _pageSize_);
            }}
          />
        </div>
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props }) => {
  const { ethnicGroup, updateEthnicGroupState, deleteEthnicGroup } =
    useEthnicGroupContext();

  const [showModal, setShowModal] = useState(false);

  const ethnic_group_id = props.ethnic_group_id;
  const ethnicGroup_name = props.name;
  const _ethnicGroup_ = props;

  const deleteOneEthnicGroupById = async (ethnic_group_id) => {
    const response = await deleteEthnicGroup(ethnic_group_id);
    if (response.data.status === 200) {
      if (ethnicGroup) {
        const update = ethnicGroup.filter(
          (_ethnicGroup_) => _ethnicGroup_.ethnic_group_id !== ethnic_group_id
        );
        updateEthnicGroupState(update);
        setShowModal(false);
      }
    }
  };

  return (
    <>
      <Modal
        props={{
          name: ethnicGroup_name,
          showModal: showModal,
          setShowModal: () => setShowModal(false),
          delete: () => deleteOneEthnicGroupById(ethnic_group_id),
        }}
      />

      <div className="flex flex-row items-center gap-2 px-0 py-0 sm:px-2 sm:py-2 text-xs">
        <Link to={editRoute}>
          <Button
            props={{
              type: "button",
              title: "Edit",
              category: "blue",
              action: "edit",
              onClick: () => {
                pushOneEthnicGroup(_ethnicGroup_);
              },
            }}
          />
        </Link>
        <Button
          props={{
            type: "button",
            title: "Delete",
            category: "red",
            action: "delete",
            onClick: () => {
              setShowModal(true);
            },
          }}
        />
      </div>
    </>
  );
};

export default Overview;
